import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import Hero from '@/pages/home/components/Hero';
import Ticker from '@/pages/home/components/Ticker';
import DailyBrief from '@/pages/home/components/DailyBrief';
import DigFeatures from '@/pages/home/components/DigFeatures';
import WallGrid from '@/pages/home/components/WallGrid';
import Evidence from '@/pages/home/components/Evidence';
import Timeline from '@/pages/home/components/Timeline';
import HotRanking from '@/pages/home/components/HotRanking';
import Columnists from '@/pages/home/components/Columnists';
import SubscribeCta from '@/pages/home/components/SubscribeCta';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-900">
      <SiteHeader />
      <main>
        <Hero />
        <Ticker />
        <DailyBrief />
        <DigFeatures />
        <WallGrid />
        <Evidence />
        <Timeline />
        <HotRanking />
        <Columnists />
        <SubscribeCta />
      </main>
      <SiteFooter />
    </div>
  );
}